/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".js-product");
      this.productForm = this.section.querySelector(".js-product-form");
      this.optionSelectors = this.querySelectorAll(
        ".option-selector:not(.option-selector--custom)"
      );
      this.nativeSelector = document.getElementById(
        `variants-${this.section.dataset.section}`
      );
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener("change", this.handleVariantChange.bind(this));
      this.applySearchParams();
      this.setupOptionSelectorClickHandler();
      this.InitshowHideAvpOption();

      this.setAttribute("loaded", "");
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.preSelection =
        !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(
        new CustomEvent("on:variant:change", {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            allVariants: this.data.variants,
            selectedOptions: this.selectedOptions,
          },
        })
      );
    }

    setupOptionSelectorClickHandler() {
      let self = this;
      // Get the parent div with the class 'option-selector__btns flex flex-wrap'
      const optionSelectorBtns = document.querySelector(
        ".option-selector__btns.flex.flex-wrap"
      );

      // Ensure the element exists
      if (optionSelectorBtns) {
        // Add a click event listener to the parent div
        optionSelectorBtns.addEventListener("click", function (event) {
          // Check if the clicked element is a radio input
          if (
            event.target &&
            event.target.matches('input[type="radio"].js-option')
          ) {
            // Get the value of the clicked radio input
            const selectedValue = event.target.value;

            // Log selected value for debugging

            setTimeout(() => {
              // Get the parent element with data-option="Color"
              const parentElement = document.querySelector(
                '.option-selector[data-option="Color"]'
              );

              // Ensure the parent element exists
              if (parentElement) {
                // Get all input elements within the parent element
                const optionInputs = Array.from(
                  parentElement.querySelectorAll("input.opt-btn")
                );

                console.log("Input options", optionInputs);

                // Find the index of the currently selected input
                const selectedInputIndex = optionInputs.indexOf(
                  document.querySelector(
                    'input[type="radio"].js-option:checked'
                  )
                );

                // Find the next visible input element
                let nextVisibleInput = null;
                for (
                  let i = selectedInputIndex + 1;
                  i < optionInputs.length;
                  i++
                ) {
                  if (optionInputs[i].style.display !== "none") {
                    nextVisibleInput = optionInputs[i];
                    break;
                  }
                }

                if (nextVisibleInput) {
                  nextVisibleInput.click();
                  console.log("Clicked next visible input ", nextVisibleInput);
                } else {
                  console.log("No next visible input found.");
                }
              } else {
                console.error(
                  "Parent element with the specified class and data-option not found."
                );
              }

              self.showHideAvpOption(selectedValue);
            }, 300); // Adjust the timeout duration if necessary
          }
        });
      } else {
        console.error("Parent element with the specified class not found.");
      }
    }

    showHideAvpOption(selectedValue) {
      return;
      if (!selectedValue) return null;

      console.log("-------------------->");
      // Get all `avp-option` elements
      const avpOptions = document.querySelectorAll(".avp-option");

      // Hide or show `avp-option` elements

      // Hide or show `avp-option` elements
      avpOptions.forEach((option) => {
        const apoTitleSpan = option.querySelector(
          ".ap-label-tooltip .apo-title"
        );
        const apoTitleSpanPd = option.querySelector(
          ".ap-options__modal .apo-modal__title"
        );

        const apoTextField = option.querySelector('input[name*="PD"]');

        console.log(apoTextField);

        //   const apoTextFieldCondition = Array.from(apoTextFields).some(input => input !== null);

        if (apoTextField) {
          console.log(apoTextField);
        }

        if (apoTitleSpanPd) {
          console.log("appppd", apoTitleSpanPd.innerHTML);
        }

        console.log("apoTitleSpan", apoTitleSpan);
        console.log("apoTitleSpanPd", apoTitleSpanPd);

        console.log("apoTextField", apoTextField);

        const apoTitleSpanInnerHTML = apoTitleSpan
          ? apoTitleSpan.innerHTML
          : "";
        const apoTitleSpanPdInnerHTML = apoTitleSpanPd
          ? apoTitleSpanPd.innerHTML
          : "";

        if (
          apoTitleSpanInnerHTML === "Prescription" ||
          apoTitleSpanPdInnerHTML === "How to Get PD" ||
          apoTextField
        ) {
          if (apoTitleSpanPd) {
            console.log("reallll", apoTitleSpanPd.innerHTML);
          }

          if (
            selectedValue === "Prescription" &&
            (apoTitleSpanPdInnerHTML === "" || apoTextField)
          ) {
            // Show the `avp-option` element
            option.style.position = "static";
            option.style.opacity = "1";
            option.style.visibility = "visible";
            option.style.height = "auto";
            option.style.overflow = "visible";
          } else {
            // Hide the `avp-option` element without leaving empty space
            option.style.position = "absolute";
            option.style.opacity = "0";
            option.style.visibility = "hidden";
            option.style.height = "0";
            option.style.overflow = "hidden";
            console.log("HIDDEN");

            console.log(option);
          }
        } else {
          // Ensure the option is shown if it does not have the `apo-title` span
          option.style.position = "static";
          option.style.opacity = "1";
          option.style.visibility = "visible";
          option.style.height = "auto";
          option.style.overflow = "visible";
        }
      });

      // Handle the file container visibility based on the selected value
      const fileContainer = document.querySelector(
        ".avp-option.ap-options__file-container"
      );

      if (fileContainer) {
        const fileInput = fileContainer.querySelector(
          'input[name="Upload Prescription"]'
        );

        if (fileInput) {
          if (selectedValue === "Prescription") {
            // Show the file container
            fileContainer.style.display = "block !important";
            fileContainer.style.position = "static";
            fileContainer.style.opacity = "1";
            fileContainer.style.visibility = "visible";
            fileContainer.style.height = "auto";
            fileContainer.style.overflow = "visible";
          } else {
            // Hide the file container
            fileContainer.style.display = "none !important";

            fileContainer.style.position = "absolute";
            fileContainer.style.opacity = "0";
            fileContainer.style.visibility = "hidden";
            fileContainer.style.height = "0";
            fileContainer.style.overflow = "hidden";
          }
        }
      }
    }

    InitshowHideAvpOption() {
      document.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => {
          const selectedOption = document.querySelector(
            '.option-selector__btns.flex.flex-wrap input[type="radio"]:checked'
          );
          if (selectedOption.value) {
            this.showHideAvpOption(selectedOption.value);
          } else {
            this.showHideAvpOption("Non Prescription");
          }
        }, 1000); // Adjust the timeout duration if necessary
      });
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn =
        this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant
        ? theme.strings.noStock
        : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists
        ? theme.strings.noStock
        : theme.strings.noVariant;
      el.classList.toggle("is-unavailable", !available);
      el.classList.toggle("is-nonexistent", !exists);
      // Check if the element has the 'is-unavailable' class
      if (el.classList.contains("is-unavailable")) {
        el.style.display = "none"; // Hide the element if it's unavailable

        // Hide the next sibling <label> if it exists
        const nextLabel = el.nextElementSibling;
        if (nextLabel && nextLabel.tagName === "LABEL") {
          nextLabel.style.display = "none";
        }
      } else {
        el.style.display = ""; // Show the element if it's not unavailable
        // Show the next sibling <label> if it exists
        const nextLabel = el.nextElementSibling;
        if (nextLabel && nextLabel.tagName === "LABEL") {
          nextLabel.style.display = "";
        }
      }

      if (optionEl.classList.contains("custom-select__option")) {
        const em = el.querySelector("em");

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        //  el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute("title");
      }

      // Automatically click the first available option
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === "false") return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'

      console.log("The dataset ", this.dataset);
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === "selection") {
        // Flag all options as unavailable
        this.querySelectorAll(".js-option").forEach((optionEl) => {
          //  VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (
                option === currVariant.options[optionIndex] &&
                optionIndex !== selectorIndex
              ) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll(".js-option");
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === "dropdown") {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(
                  optionEl,
                  true,
                  variant.available
                );
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll(
            '.js-option:not([data-value=""])'
          );
          options.forEach((option) => {
            const optionValue =
              selector.dataset.selectorType === "dropdown"
                ? option.dataset.value
                : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (
                  v.options[i] === this.selectedOptions[i] ||
                  this.selectedOptions[i] === null
                ) {
                  matches += 1;
                }
              }
              if (
                v.options[selectorIndex] === optionValue &&
                matches === selectorIndex
              ) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(
              option,
              variantsExist,
              variantsAvailable
            );
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder || this.section.querySelector(".backorder");
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === "none") {
          const backorderProdEl = this.backorder.querySelector(
            ".backorder__product"
          );
          const prodTitleEl = this.section.querySelector(".product-title");
          const variantTitle = this.variant.title.includes("Default")
            ? ""
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest(".option-selector");
      if (selector.dataset.selectorType === "dropdown") return;

      const colorText = selector.querySelector(".js-color-text");
      if (!colorText) return;

      colorText.textContent =
        evt.target.nextElementSibling.querySelector(".js-value").textContent;
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector("pickup-availability");
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute("available");
        this.pickUpAvailability.innerHTML = "";
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price =
        this.price || this.section.querySelector(".product-price .price");

      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price)
            variant = this.data.variants[i];
        }
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector(".price__current");
        const priceWasEl = this.price.querySelector(".price__was");
        const unitPriceEl = this.price.querySelector(".unit-price");

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if (priceWasEl) {
          priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || "";
        }

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector(".unit-price__price");
          const unitEl = this.price.querySelector(".unit-price__unit");
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle(
          "price--on-sale",
          variant.compare_at_price > variant.price
        );
        this.price.classList.toggle(
          "price--sold-out",
          !variant.available && !this.preSelection
        );
      }

      this.price.querySelector(".price__default").hidden =
        !this.variant && !this.preSelection;
      const noVariantPrice = this.price.querySelector(".price__no-variant");
      if (noVariantPrice) {
        noVariantPrice.hidden = this.variant || this.preSelection;
      }
      const from = this.price.querySelector(".price__from");
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector(".product-sku__value");
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : "";
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode =
        this.barcode || this.section.querySelector(".product-barcode__value");
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : "";
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false")
        return;
      const url = this.variant
        ? `${this.dataset.url}?variant=${this.variant.id}`
        : this.dataset.url;
      window.history.replaceState({}, "", url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms ||
        this.section.querySelectorAll(".js-product-form, .js-instalments-form");

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === "dropdown") {
          const selected = selector.querySelector(
            '.custom-select__option[aria-selected="true"]'
          );
          selectedOptions.push(
            selected && selected.dataset.value !== ""
              ? selected.dataset.value
              : null
          );
        } else {
          const selected = selector.querySelector("input:checked");
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    // Function to collect engraving data from the script tag
    collectEngravingData() {
      const engravingDataElement = document.querySelector(
        ".js-engraving-data-variant-media"
      );

      if (engravingDataElement) {
        const textContent = engravingDataElement.textContent.trim();

        if (textContent) {
          try {
            // Attempt to parse the JSON
            const parsedData = JSON.parse(textContent);

            // Validate that the data has the expected structure
            if (
              parsedData &&
              (Array.isArray(parsedData.variants) ||
                parsedData.variants === undefined) &&
              (parsedData.product_option ||
                parsedData.product_option === undefined)
            ) {
              return parsedData;
            } else {
              console.warn(
                "Engraving data does not have the expected structure."
              );
              return null;
            }
          } catch (error) {
            console.error("Failed to parse engraving data:", error);
            return null;
          }
        } else {
          console.warn("Engraving data script tag is empty.");
          return null;
        }
      } else {
        console.warn("Engraving data script tag not found.");
        return null;
      }
    }

    setEngravingImage(variant) {
      const engravingPreviewDiv = document.querySelector(".engraving-preview");

      if (engravingPreviewDiv) {
        // Remove existing <img> tags only
        const existingImage = engravingPreviewDiv.querySelector("img");
        if (existingImage) {
          engravingPreviewDiv.removeChild(existingImage);
        }

        const engravingData = this.collectEngravingData();

        // if (!engravingData || !engravingData.variants) {
        //   console.warn("No engraving data available.");
        //   return;
        // }

        console.log("Engraving Data--->", engravingData);

        // Find the engraving data that matches the variant title
        // const engravingDataFind = engravingData.variants.find(
        //   (engraving) => engraving.variant_name === variant.title
        // );

        const engravingDataFind = document.querySelector(
          "#engraving-meta-image"
        ).src;
        let img;
        //img.src = document.querySelector("#engraving-meta-image").src;
        if (engravingDataFind) {
          // If a matching variant engraving preview is found, create the image element
          img = document.createElement("img");
          img.src = document.querySelector("#engraving-meta-image").src;
          console.log(document.querySelector("#engraving-meta-image").src);
          img.alt = `${variant.title} Engraving Preview`;
          console.log("Variant Engraving Data Displayed");
        } else if (engravingData.product_option) {
          // If no matching variant engraving preview is found, create the product option image element
          img = document.createElement("img");
          img.src = document.querySelector("#engraving-meta-image").src;
          img.alt = "Product Engraving Preview";
          console.log("Product Option Engraving Data Displayed");
        } else {
          console.warn(
            "No engraving data found for the selected variant or product option."
          );
        }

        if (img) {
          // Insert the new image as the first element
          engravingPreviewDiv.insertBefore(img, engravingPreviewDiv.firstChild);
        }
      } else {
        console.warn("Engraving preview div not found.");
      }
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const variant = this.data.variants.find((v) =>
        v.options.every((val, index) => val === this.selectedOptions[index])
      );

      let hideVisionTab = false;

      // Select the container with the class 'product-activity-icons'

      if (variant) {
        setTimeout(() => {
          this.setEngravingImage(variant);
        }, 3000);

        // Normalize variant title to match image class naming convention
        const normalizedTitle = variant.title.replace(/ /g, "");

        // Define image types and their corresponding class prefixes
        const imageTypes = [
          { type: "vision", prefix: "vision-" },
          { type: "spectrum", prefix: "spectrum-" },
          { type: "lens", prefix: "lens-" },
          { type: "prescription", prefix: "prescription-" },
        ];

        // Hide all images with classes starting with defined prefixes
        imageTypes.forEach(({ prefix }) => {
          document.querySelectorAll(`[class^="${prefix}"]`).forEach((img) => {
            img.style.display = "none";
          });
        });

        // Show images based on variant title
        imageTypes.forEach(({ type, prefix }) => {
          const imageClass = `${prefix}${normalizedTitle}`;
          const imagesToShow = document.querySelectorAll(
            `.${CSS.escape(imageClass)}`
          );

          console.log("imageclass", imageClass);

          const parentAccordion = document
            .querySelector(`.${CSS.escape(imageClass)}`)
            ?.closest(".product-info-accordion");

          console.log("PARENT", parentAccordion);

          // Special handling for 'lens' type to show all images
          if (type === "lens" && imagesToShow.length > 0) {
            imagesToShow.forEach((img) => {
              img.style.display = "block";
            });
          } else {
            const imageToShow = document.querySelector(
              `.${CSS.escape(imageClass)}`
            );

            if (imageToShow) {
              imageToShow.style.display = "block";
              if (parentAccordion) {
                parentAccordion.style.display = "block";
              }

              if (type == "prescription") {
                if (!imageToShow || !imageToShow.innerHTML.trim()) {
                  console.log("The element is empty.");

                  document.querySelector(
                    ".prescription.prescription_default"
                  ).style.display = "block";
                } else {
                  parentAccordion.style.display = "block";
                  document.querySelector(
                    ".prescription.prescription_default"
                  ).style.display = "none";
                }
              }
              if (type == "vision") {
                if (!imageToShow.innerHTML.trim()) {
                  hideVisionTab = true;
                } else {
                  hideVisionTab = false;
                }
              }
            } else {
              console.warn(`No ${type} image found with class ${imageClass}`);

              if (parentAccordion) {
                parentAccordion.style.display = "none";
              }
            }
          }
        });
      }

      // List of classes to check
      const classesToCheck = [
        "VisionColor",
        "SpectrumReport",
        "Lenses",
        "PrescriptionInsert",
      ];

      classesToCheck.forEach((className) => {
        // Select all elements with the current class
        const elements = document.querySelectorAll(`.${className}`);

        elements.forEach((element) => {
          // Find all images within this element
          const images = element.querySelectorAll("img");

          // Check if all images are hidden
          const allImagesHidden = Array.from(images).every(
            (img) => getComputedStyle(img).display === "none"
          );

          // Show or hide the element based on image visibility
          if (allImagesHidden) {
            element.style.display = "none";
          } else {
            element.style.display = "block"; // or any other display value you want
          }
        });
      });

      // Check if the element exists in the DOM
      const prescriptionInsert = document.querySelector(".PrescriptionInsert");

      if (prescriptionInsert) {
        // Proceed only if the element is found
        if (variant?.title.includes("Non-Prescription")) {
          // Hide the element if 'Non-Prescription' is found in variant.title
          console.log("The title contains 'Non-Prescription'.");
          prescriptionInsert.style.display = "none";
        } else {
          // Show the element if 'Non-Prescription' is not found in variant.title
          console.log("The title does not contain 'Non-Prescription'.");
          prescriptionInsert.style.display = "block";
        }
      } else {
        console.log("The element '.PrescriptionInsert' was not found.");
      }

      const visionTab = document.querySelector(
        ".product-info-accordion.VisionColor"
      );

      if (visionTab) {
        if (hideVisionTab) {
          visionTab.style.display = "none";
        } else {
          visionTab.style.display = "block";
        }
      } else {
        console.log("VisionColor tab not found");
      }

      return variant;
    }

    /**
     * Apply search parameters.
     */
    applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);

      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
        const optionSelectors = Array.from(this.optionSelectors);
        const matchingOptionSelector = optionSelectors.find(
          (x) => x.dataset.option === key
        );
        if (!matchingOptionSelector) return;

        if (matchingOptionSelector.dataset.selectorType === "dropdown") {
          const colorOptionDropdown = matchingOptionSelector.querySelector(
            `.custom-select__option[data-value="${value}"]`
          );
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest("custom-select");
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          const matchingInput = matchingOptionSelector.querySelector(
            `input[value="${value}"]`
          );
          if (matchingInput) {
            const matchingOptionValue = matchingOptionSelector.querySelector(
              ".option-selector__label-value"
            );
            if (matchingOptionValue) {
              matchingOptionSelector.querySelector(
                ".option-selector__label-value"
              ).textContent = value;
            }
            matchingInput.checked = true;
            matchingInput.dispatchEvent(
              new CustomEvent("change", { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
